import { Injectable } from '@angular/core';
import { ProductService } from 'src/api/services/product.service';
import { Product } from 'src/api/models/product';
import { BehaviorSubject, Observable } from "rxjs";
import { StrictHttpResponse } from 'src/api/strict-http-response';
import { ToastrService } from 'ngx-toastr';



@Injectable()
export class ProductTableService {

    public data: Product[];
    public remoteData: Observable<Product[]>;
    private _remoteData: BehaviorSubject<Product[]>;

    constructor(private readonly service: ProductService, private toasterService: ToastrService) {
      this._remoteData = new BehaviorSubject([]);
      this.remoteData = this._remoteData.asObservable();
    }

    get() {
      this.service.ProductGetAllProducts().subscribe(results => {
        console.log(results);
        this._remoteData.next(results);
        this.data = results;
      });
    }

    add(product: Product) : Observable<Product> {
      return this.service.ProductCreateProduct(product)
    }

    remove(product: Product) {
      return this.service.ProductDeleteProductById(product.productId).subscribe(r => {
        var index = this.data.indexOf(product);
        this.data.splice(index, 1);
        this.toasterService.success('Successfully Deleted Product', 'Delete Product');
      }, err => {

        this.toasterService.error('Failed to Delete Product: ' + err.error.text, 'Delete Product');
      });
    }

    update(product: Product) : Observable<Product> {
      return this.service.ProductUpdate(product);
    }
    


}
